import { render, staticRenderFns } from "./StarSeries.vue?vue&type=template&id=2712b9c0&"
import script from "./StarSeries.vue?vue&type=script&lang=js&"
export * from "./StarSeries.vue?vue&type=script&lang=js&"
import style0 from "./StarSeries.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StarSeries.vue"
export default component.exports